export class TeamWorkloadSummaryEntity {
  public overCapacityCount!: number;
  public overdueCasesCount!: number;
  public atRiskCasesCount!: number;
  public plannedTimeOffCount!: number;
}
